/* eslint-disable @typescript-eslint/no-explicit-any */
export type DataTypeFilter = "divergence" | "nsu";

export const DATA_TYPE = {
  DIVERGENCE: "divergence" as DataTypeFilter,
  NSU: "nsu" as DataTypeFilter,
} as const;

export interface FilterStateStoreEmail {
  filters: {
    search: string;
    date?: string;
    conciliation_date_range?: {
      start?: string;
      end?: string;
    };
    store_code?: string[] | string;
    analyst?: string[] | string;
    status?: string[] | string;
    justification_id?: string[] | string;
    type?: string[] | string;
    payroll_voucher_status?: string[] | string;
    dataType: DataTypeFilter;
    order?: any;
    meta: {
      page: number;
      perPage: number;
    };
    [key: string]: any;
  };
}
